export const isIosSafari = () => {
  if (typeof navigator === 'undefined') return false;
  return (
    /iP(?:ad|hone|od)/.test(navigator.userAgent) &&
    /Safari/.test(navigator.userAgent) &&
    !/CriOS|FxiOS/.test(navigator.userAgent)
  );
};
